<template>
  <div :class="{ 'space-placeholder': placeHolderSpace }">
    <span v-if="label" class="input-label">
      {{ $t(label) }}
    </span>
    <v-textarea
      :class="['mt-1', customClass, { 'hide-scroll': !needsScroll }]"
      style="font-size: 16px"
      :model-value="modelValue"
      color="primary"
      variant="outlined"
      :type="type"
      :disabled="disabled"
      loading-color="primary"
      :placeholder="placeholder ? $t(placeholder) : ''"
      :readonly="readonly"
      @input="
        $emit('update:modelValue', $event.target.value);
        checkScroll();
      "
      :rows="rows"
      :no-resize="noResize"
      :density="density"
      :rounded="rounded"
      hide-details="auto"
      :rules="rules"
      :auto-grow="autoGrow"
      v-bind="{ bgColor: bgColor || undefined }"
      :hint="hint ? $t(hint) : ''"
      persistent-hint
      :counter="counter"
      ref="textareaRef"
    ></v-textarea>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  placeHolderSpace: {
    type: Boolean,
    default: true,
  },
  label: {
    type: String,
    default: "",
  },
  modelValue: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: "text",
  },
  placeholder: {
    type: String,
    default: "",
  },
  customClass: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  rows: {
    type: String,
    default: "3",
  },
  rules: {
    type: Array,
    default: [],
  },
  noResize: Boolean,
  density: {
    type: String,
    default: "default",
  },
  rounded: {
    type: String,
    default: "lg",
  },
  autoGrow: Boolean,
  bgColor: String,
  hint: String,
  counter: {
    type: [String, Boolean, Number],
    default: false,
  },
});

const textareaRef = ref(null);
const needsScroll = ref(false);
const checkScroll = () => {
  if (textareaRef.value) {
    const textarea = textareaRef.value.$el.querySelector("textarea");
    needsScroll.value = textarea.scrollHeight > textarea.clientHeight;
  }
};
</script>

<style>
.space-placeholder textarea::placeholder {
  line-height: 65px !important;
}
.space-placeholder textarea::-moz-placeholder {
  line-height: 65px !important;
}
.space-placeholder textarea::-webkit-input-placeholder {
  line-height: 65px !important;
}
.space-placeholder textarea::-ms-placeholder {
  line-height: 65px !important;
}

/* Hide scrollbar if content doesn't overflow */
.hide-scroll textarea {
  overflow: hidden !important;
}
</style>
